import { atom } from 'jotai';

import { Plan } from '@/_generated/api-clients/xp';
import { store } from '@/atoms';

export type PrintablePlan = Pick<Plan, 'id' | 'type' | 'name'> &
  Partial<Pick<Plan, 'category' | 'readonly' | 'ownerId' | 'ownerType'>>;

export interface PlanPrintSubject {
  type: 'plan';
  plan: PrintablePlan;
}

// Team member print subject - for printing team member summary reports
// Data fetching is co-located in PrintReport component
export interface TeamMemberPrintSubject {
  type: 'teamMember';
  id: string;
  name: string;
}

export type PrintReportSubject = PlanPrintSubject | TeamMemberPrintSubject;

export interface PrintReportState {
  subject: PrintReportSubject | null;
  showDoB: boolean;
}

export const printReportAtom = atom<PrintReportState>({
  subject: null,
  showDoB: false,
});

// Ergonomic helpers for triggering print (write-only atoms)

/** Close print report modal and reset state */
export const closePrintReportAtom = atom(null, (_get, set) => {
  set(printReportAtom, { subject: null, showDoB: false });
});

/** Set showDoB flag */
export const setShowDoBAtom = atom(null, (_get, set, showDoB: boolean) => {
  set(printReportAtom, prev => ({ ...prev, showDoB }));
});

// Imperative helpers - callable from anywhere (not just React components)

export const printPlan = (plan: PrintablePlan) => {
  store.set(printReportAtom, prev => ({
    ...prev,
    subject: { type: 'plan', plan },
  }));
};

/** Trigger print report modal for a team member summary */
export const printTeamMember = (
  details: Omit<TeamMemberPrintSubject, 'type'>,
) => {
  store.set(printReportAtom, prev => ({
    ...prev,
    subject: { type: 'teamMember', ...details },
  }));
};

/** Close print report modal and reset state */
export const closePrintReport = () => {
  store.set(printReportAtom, { subject: null, showDoB: false });
};
